export default __webpack_public_path__ + "static/media/cleaning-car.81b3575c.png";